export const RADIO_FILTER_WARNINGS_ALL = { label: 'All Warnings', key: 'date-all' };
export const RADIO_FILTER_ALL = { label: 'All', key: 'all' };
